<template>
  <div>
    <v-btn icon @click="dialog = true" style="background-color: transparent;">
      <v-icon>mdi-information</v-icon>
    </v-btn>
    
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ header }}</v-card-title>
        <v-card-text>
          <slot />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    setup(props){
      return {
        dialog: props.header,
      }
    },
    props: {
      header: {
        type: String,
        default: "Information",
      },
    },
    data() {
      return {
        dialog: false,
      };
    },
  };
</script>